import React, { useContext, memo } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { Link, useLocation } from 'react-router-dom';
import { ReviewsTabId } from '../../product-tabs/constants';

const LinkToReviewsComponent: React.FC<ILinkToReviewsProps> = ({
  children,
  onClick,
}) => {
  const location = useLocation();
  const { t } = useContext(AppContext);
  const to = `${location.pathname}${location.search}${ReviewsTabId}`;

  return (
    <Link to={to} onClick={onClick} aria-label={t('product', 'tabs.reviews')}>
      {children}
    </Link>
  );
};

interface ILinkToReviewsProps {
  onClick?: (ev: React.MouseEvent) => void;
  children: React.ReactNode | null;
}

export const LinkToReviews = memo(LinkToReviewsComponent);
